import { EventEmitter } from "pixi.js";

export enum EnumColorOptEventBus {
  selectedColor = "SELECTED_COLOR"
}

export const colorOptEventBus = new EventEmitter();